var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4015_50117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28564 6.00021C4.28564 5.52682 4.6694 5.14307 5.14279 5.14307L18.8571 5.14307C19.3305 5.14307 19.7142 5.52682 19.7142 6.00021C19.7142 6.4736 19.3305 6.85735 18.8571 6.85735L5.14279 6.85735C4.6694 6.85735 4.28564 6.4736 4.28564 6.00021Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28564 11.1428C4.28564 10.6694 4.6694 10.2856 5.14279 10.2856L18.8571 10.2856C19.3305 10.2856 19.7142 10.6694 19.7142 11.1428C19.7142 11.6162 19.3305 11.9999 18.8571 11.9999L5.14279 11.9999C4.6694 11.9999 4.28564 11.6162 4.28564 11.1428Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28564 16.2859C4.28564 15.8125 4.6694 15.4287 5.14279 15.4287L18.8571 15.4287C19.3305 15.4287 19.7142 15.8125 19.7142 16.2859C19.7142 16.7592 19.3305 17.143 18.8571 17.143L5.14279 17.143C4.6694 17.143 4.28564 16.7592 4.28564 16.2859Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4015_50117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.8262e2333ef10b808e173f0eae8fc485.svg";
export { ForwardRef as ReactComponent };